import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const AppointmentList = {
	name: NAME,
	apiProvider,
	router,
};
